import React, { Dispatch, SetStateAction, useState } from "react";
import { Modal, Button, Loading } from "@alm/flow-ds/components";
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router-dom";

interface Props {
	title: string;
	content: string | JSX.Element;
	deleteElement: () => Promise<void> | void;
	isOpen: boolean;
	setIsOpen?: Dispatch<SetStateAction<boolean>>;
}

const DeleteDialog = ({
	title,
	content,
	deleteElement,
	isOpen,
	setIsOpen,
}: Props) => {
	const { t } = useTranslation();

	const history = useHistory();

	const [deleteLoading, setDeleteLoading] = useState(false);

	const handleClose = () => (setIsOpen ? setIsOpen(false) : history.goBack());

	return isOpen ? (
		<Modal
			className="delete-activity-dialog"
			close={handleClose}
			isOpen={isOpen}
			title={title}
			modalSize="md"
			showHeaderClose
			footer={
				<div>
					<Button
						label={t("common.labels.cancel")}
						className="btn-default"
						onClick={handleClose}
					/>
					<Button
						label={!deleteLoading && t("common.labels.delete")}
						className="btn-primary"
						onClick={async () => {
							setDeleteLoading(true);
							await deleteElement();
							setDeleteLoading(false);
							handleClose();
						}}>
						{deleteLoading && <Loading />}
					</Button>
				</div>
			}>
			{typeof content === "string" ? <p>{content}</p> : content}
		</Modal>
	) : null;
};

export default DeleteDialog;
